import {
  forwardRef,
  useEffect,
  useCallback,
} from 'react';
import { useLocation } from 'react-router-dom';
import {
  node,
  oneOf,
  string,
} from 'prop-types';
import {
  Container,
  makeStyles,
} from '@material-ui/core';

import { SITE_TITLE } from 'settings';
import track from 'utils/analytics';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  cronInput: {
    marginTop: theme.spacing(2),
  },
}));

const Page = forwardRef(({
  children,
  className,
  favicon,
  maxWidth,
  siteTitle,
  title,
  ...rest
}, ref) => {
  const classes = useStyles();
  const location = useLocation();

  const sendPageViewEvent = useCallback(() => {
    track.pageview({
      page_path: location.pathname,
    });
  }, [location]);

  useEffect(() => {
    sendPageViewEvent();
  }, [sendPageViewEvent]);

  useEffect(() => {
    const { REACT_APP_STAGE: APP_STAGE } = process.env;
    const stage = APP_STAGE !== 'production' ? ` (${APP_STAGE})` : '';
    const company = localStorage.getItem('company');

    let finalTitle = siteTitle || SITE_TITLE;
    let finalFavicon = favicon || '/favicon.ico';
    
    if (company) {
      try {
        const companyData = JSON.parse(company);
        if (companyData?.site?.title) {
          finalTitle = companyData.site.title;
        }
        if (companyData?.site?.favicon) {
          finalFavicon = companyData.site.favicon;
        }
      } catch (error) {
        console.error('Error parsing company data:', error);
      }
    }
    
    document.title = `${title ? `${title} - ` : ''}${finalTitle}${stage}`;
    document.querySelector('link[rel="icon"]').href = finalFavicon;
    
  }, [title, favicon, siteTitle]);
  return (
    <div className={`${classes.root} ${className || ''}`} ref={ref} {...rest}>
      <Container
        children={children}
        maxWidth={maxWidth}
      />
    </div>
  );
});

Page.defaultProps = {
  maxWidth: false,
};

Page.displayName = 'Page';

Page.propTypes = {
  children: node,
  className: string,
  favicon: string,
  maxWidth: oneOf([
    'lg',
    'md',
    'sm',
    'xl',
    'xs',
    false,
  ]),
  siteTitle: string,
  title: string,
};

export default Page;
